<ng-container>
  <h1 class="h3 mb-3"><strong>List</strong> Customers Subscription</h1>
</ng-container>
<div  class="list-layout">
  <table-view
    [isLoading] = isScreenLoading
    [tableConfiguration] = "tableConfiguration">
  </table-view>
</div>
